(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CafWithNoService', CafWithNoService);

    CafWithNoService.$inject = ['$resource', 'DateUtils'];

    function CafWithNoService ($resource, DateUtils) {
        var resourceUrl =  'api/caf-with-no-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.applicationdate = DateUtils.convertDateTimeFromServer(data.applicationdate);
                        data.createddate = DateUtils.convertDateTimeFromServer(data.createddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
